import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import LogoTitle from '../../assets/images/logo-s.png'
import Logo from './Logo'
import Particles from 'react-tsparticles'
import particlesconfig from './Config/particles.config'
import './index.scss'
import { loadFull } from 'tsparticles'

const Home = () => {
  const particlesInit = async (main) => {
    await loadFull(main)
  }

  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = ['o', 'u', 's', 's', 'e', 'f', ',']
  const jobArray = [
    'f',
    'u',
    'l',
    'l',
    ' ',
    's',
    't',
    'a',
    'c',
    'k',
    ' ',
    'e',
    'n',
    'g',
    'i',
    'n',
    'e',
    'e',
    'r',
    '.',
  ]

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 5200)

    return () => clearTimeout(timeoutId)
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i</span>
            <span className={`${letterClass} _13`}>,</span>
            <br />
            <span className={`${letterClass} _14`}>I</span>
            <span className={`${letterClass} _15`}>'</span>
            <span className={`${letterClass} _16`}>m</span>
            <img src={LogoTitle} alt="Full Stack Software Engineer Name" />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
            />
          </h1>
          <h2>
            Java / Spring Boot · Node.js · Python / FastAPI · React &amp;
            Next.js · AI &amp; Cloud
          </h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        <Logo />
      </div>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particlesconfig}
      />
      <Loader type="pacman" />
    </>
  )
}

export default Home
